import { makeApiCall } from '../../../../services/apiService/apiService';
import { toastr } from 'react-redux-toastr';
import { entityTypes, sortTableData } from '../helper';

export const prsDrsCostApprovalActions = {
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_PRS_DRS_DATA: 'SET_PRS_DRS_DATA',
  SET_PRS_OR_DRS_CONSIGNMENT_DATA: 'SET_PRS_OR_DRS_CONSIGNMENT_DATA',
  SET_LOADING_SUB_ROW: 'SET_LOADING_SUB_ROW',
  SET_CONSIGNMENTS_FOR_PRS_DRS: 'SET_CONSIGNMENTS_FOR_PRS_DRS',
  SET_HANDLING_COST_COMPONENTS: 'SET_HANDLING_COST_COMPONENTS',
  SET_REJECTION_REASONS: 'SET_REJECTION_REASONS',
  SET_LOADER_MODAL: 'SET_LOADER_MODAL'
};

const setConsignmentsForRow = (rowIndex, payload) => {
  return {
    type: prsDrsCostApprovalActions.SET_CONSIGNMENTS_FOR_PRS_DRS,
    payload: {
      rowIndex: rowIndex,
      subRows: payload
    }
  };
};

const setLoaderModal = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_LOADER_MODAL,
    payload: payload
  };
};
const setRejectionReasons = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_REJECTION_REASONS,
    payload: payload
  };
};

const setLoadingSubRow = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_LOADING_SUB_ROW,
    payload: payload
  };
};
const setLoading = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_IS_LOADING,
    payload: payload
  };
};

const setPrsDrsData = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_PRS_DRS_DATA,
    payload: payload
  };
};

const setHandlingCostComponents = payload => {
  return {
    type: prsDrsCostApprovalActions.SET_HANDLING_COST_COMPONENTS,
    payload: payload
  };
};

export const getConsginmentsForPrsDrs = (
  entityType,
  prsOrDrsId,
  rowIndex
) => dispatch => {
  dispatch(setLoadingSubRow(true));

  let apiToUse = '';
  let pathVariables = [];
  let replaceParamsArr = [];

  if (entityType === entityTypes.PRS) {
    apiToUse = 'getConsignmetsForPrs';
    pathVariables = [];
    replaceParamsArr = [{ key: 'prsId', val: prsOrDrsId }];
  } else {
    apiToUse = 'getConsignmentsForDrs';
    pathVariables = [{ key: '{drsId}', val: prsOrDrsId }];
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: apiToUse,
    pathVariables: pathVariables,
    replaceParamsArr:
      replaceParamsArr && replaceParamsArr.length > 0 ? replaceParamsArr : null,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(setLoadingSubRow(false));
        dispatch(
          setConsignmentsForRow(
            rowIndex,
            entityType === entityTypes.PRS
              ? res.payload
              : res.payload && res.payload.consignments
          )
        );
      } else if (res.status === 'FAILURE') {
        dispatch(setLoadingSubRow(false));
        dispatch(setConsignmentsForRow(rowIndex, []));
      }
    },
    failureCb: res => {
      dispatch(setConsignmentsForRow(rowIndex, []));
      dispatch(setLoadingSubRow(false));
      // eslint-disable-next-line no-console
      console.log(' Failure in taking action');
    },
    catchCb: res => {
      dispatch(setConsignmentsForRow(rowIndex, []));
      dispatch(setLoadingSubRow(false));
      // eslint-disable-next-line no-console
      console.log(' Exception in taking action', res);
    }
  };

  makeApiCall(requestObj);
};

export const approveOrRejectPrsDrs = (data, callback) => dispatch => {
  dispatch(setLoaderModal(true));
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    method: 'POST',
    apiEndPoint: 'prsDrsCostApprovalAction',
    data: data,
    successCb: res => {
      dispatch(setLoaderModal(false));
      if (res.status === 'SUCCESS') {
        toastr.success(
          data.action === 'APPROVED'
            ? 'Cost Approved Successfully'
            : 'Action taken Sucessfully'
        );
        if (callback) {
          callback();
        }
      } else if (res.status === 'FAILURE') {
      }
    },
    failureCb: res => {
      dispatch(setLoaderModal(false));
      // eslint-disable-next-line no-console
      console.log(' Failure in taking action');
    },
    catchCb: res => {
      dispatch(setLoaderModal(false));
      // eslint-disable-next-line no-console
      console.log(' Exception in taking action', res);
    }
  };

  makeApiCall(requestObj);
};

export const getPrsDrs = (
  entityType,
  expenseType,
  startDate,
  endDate,
  callback
) => dispatch => {
  dispatch(setLoading(true));
  dispatch(setPrsDrsData([]));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getPrsDrsForCostApproval',
    pathVariables: [
      { key: '{entityType}', val: entityType },
      { key: '{expenseType}', val: expenseType }
    ],
    replaceParamsArr: [
      { key: 'fromDateTime', val: startDate },
      { key: 'toDateTime', val: endDate }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(setLoading(false));
        const sortedPrsDrsData = (res && res.payload) || [];
        sortTableData(sortedPrsDrsData);
        dispatch(setPrsDrsData(sortedPrsDrsData));
        if (callback) {
          callback(sortedPrsDrsData);
        }
      } else if (res.status === 'FAILURE') {
      }
    },
    failureCb: res => {
      dispatch(setLoading(false));
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching getSearchResultsAction, res= ', res);
    },
    catchCb: res => {
      dispatch(setLoading(false));
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching getSearchResultsAction', res);
      toastr.error('Error', 'something went wrong');
    }
  };

  makeApiCall(requestObj);
};

export const getReasonsForRejection = () => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getRejectionReasons',
    replaceParamsArr: [{ key: 'reasonType', val: 'EXPENSE_REJECTION' }],
    successCb: res => {
      dispatch(setLoading(false));
      if (res.status === 'SUCCESS') {
        dispatch(setRejectionReasons(res.payload));
      } else if (res.status === 'FAILURE') {
        dispatch(setRejectionReasons([]));
      }
    },
    failureCb: res => {
      dispatch(setLoading(false));
      dispatch(setRejectionReasons([]));
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching reasons for rejection, res= ', res);
    },
    catchCb: res => {
      dispatch(setLoading(false));
      dispatch(setRejectionReasons([]));
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching reasons for rejection', res);
      toastr.error('Error', 'something went wrong');
    }
  };
  makeApiCall(requestObj);
};

export const getComponentsHandlingCost = expenseId => dispatch => {
  dispatch(setLoaderModal(true));
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getHandlingCostComponents',
    pathVariables: [{ key: '{expenseId}', val: expenseId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        const data = [...res.payload];

        (data || []).forEach(ele => {
          ele.isEditing = false;
        });
        dispatch(setLoaderModal(false));
        dispatch(setHandlingCostComponents(data));
      } else if (res.status === 'FAILURE') {
        dispatch(setLoaderModal(false));
        dispatch(setHandlingCostComponents([]));
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      dispatch(setLoaderModal(false));
      dispatch(setHandlingCostComponents([]));
      console.log(' Failure in fetching getSearchResultsAction, res= ', res);
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      dispatch(setHandlingCostComponents([]));
      console.log(' Exception in fetching getSearchResultsAction', res);
      toastr.error('Error', 'something went wrong');
    }
  };

  makeApiCall(requestObj);
};
